module.exports = __webpack_public_path__ + "static/media/app-store-rectangle.3fcfe44f.svg";